import { render } from "./USWDSTable.vue?vue&type=template&id=f99f2d68"
import script from "./USWDSTable.vue?vue&type=script&lang=js"
export * from "./USWDSTable.vue?vue&type=script&lang=js"

import "./USWDSTable.vue?vue&type=style&index=0&id=f99f2d68&lang=scss"

import exportComponent from "/builds/wma/osd/decap/configuration-depot/configuration-depot-application/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__